/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import {
  Loading,
  Text,
  EmptyState,
  Icon,
  WithTooltip
} from 'components/common/Elements/Elements';

import BodyTooltip from '../../../parts/BodyTooltip/BodyTooltip';

import { iconName } from '../../../helpers/helpers';
import { upFirstLetter } from 'utils/common';

import classes from './TableWidget.module.scss';

const TableWidget = ({ data = [], loader }) => {
  const objForTooltip = (data, labelForPars) =>
    Array.isArray(data) && data.length > 0
      ? data.reduce((obj, item) => {
          const label = item[labelForPars];
          if (!(label in obj)) {
            obj[label] = [];
          }
          obj[label].push(item);
          return obj;
        }, {})
      : {};

  const parsOption = data => {
    return Object.keys(data);
  };

  return (
    <>
      <table className={classes.table}>
        <thead>
          <tr className={classes.tr}>
            <th className={classes.th}>
              <Text weight={'m'} size={6} className={classes.field}>
                Priority
              </Text>
            </th>
            <th className={classes.th}>
              <Text weight={'m'} size={6} className={classes.field}>
                Rule Name
              </Text>
            </th>
            <th className={classes.th}>
              <Text weight={'m'} size={6} className={classes.field}>
                Action
              </Text>
            </th>
            <th className={classes.th}>
              <Text weight={'m'} size={6} className={classes.field}>
                Source
              </Text>
            </th>
            <th className={classes.th}>
              <Text weight={'m'} size={6} className={classes.field}>
                Destinations
              </Text>
            </th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 &&
            data.map((rule, index) => (
              <tr className={classes.ddd} key={index}>
                <td className={classes.tdBody}>
                  <Text size={6}>{rule.priority}</Text>
                </td>
                <td className={classes.tdBody}>
                  <Text type={'p'}>{rule.ruleName}</Text>
                </td>
                <td className={cn(classes.tdBody, classes.tdBody_btn)}>
                  <Text
                    className={cn(
                      classes.status,
                      rule.status === 'active'
                        ? classes.status_active
                        : classes.status_inactive
                    )}
                  >
                    {upFirstLetter(rule.status)}
                  </Text>
                </td>
                <td className={cn(classes.tdBody, classes.tdBody_btn)}>
                  {rule.sources.length > 0 ? (
                    parsOption(objForTooltip(rule.sources, 'sourceType')).map(
                      (item, index) => (
                        <WithTooltip
                          className={classes.tooltip}
                          placement={'top-start'}
                          text={
                            <BodyTooltip
                              name={item}
                              icon={iconName(item)}
                              subName={'sourceName'}
                              data={
                                objForTooltip(rule.sources, 'sourceType')[item]
                              }
                            />
                          }
                          key={index}
                        >
                          <div className={classes.tooltipHover}>
                            <div className={classes.notifWrap}>
                              <Icon
                                icon={iconName(item)}
                                className={classes.icon}
                                size="16px"
                              />
                              <Text className={classes.notif} weight="m">
                                {`${upFirstLetter(item)} (${
                                  objForTooltip(rule.sources, 'sourceType')[
                                    item
                                  ].length
                                })`}
                              </Text>
                            </div>
                            <p style={{ display: 'none' }} />
                          </div>
                        </WithTooltip>
                      )
                    )
                  ) : (
                    <div className={classes.notifWrap}>
                      <Icon icon={'Any'} className={classes.icon} size="16px" />
                      <Text>Any</Text>
                    </div>
                  )}
                </td>
                <td className={cn(classes.tdBody, classes.tdBody_btn)}>
                  {rule.destinations.length > 0 ? (
                    parsOption(
                      objForTooltip(rule.destinations, 'destinationType')
                    ).map((item, index) => (
                      <WithTooltip
                        className={classes.tooltip}
                        placement={'top-start'}
                        text={
                          <BodyTooltip
                            name={item}
                            icon={iconName(item)}
                            subName={'destinationName'}
                            data={
                              objForTooltip(
                                rule.destinations,
                                'destinationType'
                              )[item]
                            }
                          />
                        }
                        key={index}
                      >
                        <div className={classes.tooltipHover}>
                          <div className={classes.notifWrap}>
                            <Icon
                              icon={iconName(item)}
                              className={classes.icon}
                              size="16px"
                            />
                            <Text className={classes.notif} weight="m">
                              {`${upFirstLetter(item)} (${
                                objForTooltip(
                                  rule.destinations,
                                  'destinationType'
                                )[item].length
                              })`}
                            </Text>
                          </div>
                          <p style={{ display: 'none' }} />
                        </div>
                      </WithTooltip>
                    ))
                  ) : (
                    <div className={classes.notifWrap}>
                      <Icon icon={'Any'} className={classes.icon} size="16px" />
                      <Text>Any</Text>
                    </div>
                  )}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {loader ? <Loading /> : data.length === 0 && <EmptyState />}
    </>
  );
};

TableWidget.propTypes = {
  data: PropTypes.array,
  loader: PropTypes.bool
};

export default TableWidget;
